import axios from "axios";
import {
	METHOD_TYPE,
	GRAPHQL_ENDPOINT,
	ATTRIBUTE_TYPE,
	LANGUAGE_ARRAY,
	OFFER_TYPES,
	OFFER_TYPES_ENUM
} from "@/common/utils/constants";
import {maturities} from "@/gop/services/gop.validation.service";

const URL = process.env.VUE_APP_BACKEND_API_URL;
let endpoint = `${URL}/gop/main`;
let statisticEndpoint = `${URL}/gop/statistics`

export function initializeForm(creatorId, languageId = 1) {
	return axios.post(`${endpoint}/offers/initialize`, {creatorId, languageId}).then(response => {
		return response.data;
	})
}

export function getFormData(offerId) {
	return axios.get(`${endpoint}/offers/${offerId}/submission-form`).then(response => {
		return response.data;
	})
}

export function cloneGlobalOfferFiles(localizedOfferId, globalOfferId) {
	return axios.post(`${endpoint}/offers/${globalOfferId}/clone-to/${localizedOfferId}`).then(response => {
		return response.data;
	})
}

export function getTranslatedOffer(creatorId, offerId, fromLanguage, toLanguageId){
	const data = {
		"initializer": {
			"languageId": toLanguageId,
			"creatorId": creatorId
		},
		"fromLanguage": fromLanguage,
		"fromOfferId": offerId
	}

	return axios.post(`${endpoint}/offers/translations/submission-form`, data).then(response => {
		return response.data;
	});
}

export const countriesEnums = {
	DELIVERY_LOCATION: "DELIVERY_LOCATION",
	FASTEST_GROWING_MARKETS: "FASTEST_GROWING_MARKET",//note the missing S
	LARGEST_MARKETS: "LARGEST_MARKET",//note the missing S
}

export function formatNewQualificationAttributes(form) {
	const arr = [];
	form.toolsAndSystems.forEach((tool) => {
		if (!tool.id) {
			arr.push({name: tool.name, type: ATTRIBUTE_TYPE.tool})
		}
	});

	form.certifications.forEach((certification) => {
		if (!certification.id) {
			arr.push({name: certification.name, type: ATTRIBUTE_TYPE.certification})
		}
	})

	return arr;
}

export function fillFormDataWithOffer(offer, form, validationService) {
	const languageIndex = offer.translations.findIndex(el => el.languageId === offer.submission.languageId) || 0;

	form.videoLinks = [];
	offer.videoLinks.forEach((videoLink) => {
		form.videoLinks.push({
			id: videoLink.id,
			videoLinkName: videoLink.name,
			videoLinkUrl: videoLink.url
		})
	})
	if(form.videoLinks.length === 0) {
		form.videoLinks.push({videoLinkName: "", videoLinkUrl: ""})
	}

	form.language = [LANGUAGE_ARRAY.find(el => el.id === offer.translations[languageIndex].languageId)];

	form.title = offer.translations[languageIndex].title || '';
	form.description = offer.translations[languageIndex].description || '';
	form.biggestMarketConclusion = offer.translations[languageIndex].biggestMarketConclusion || '';
	form.keyMarketDrivers = offer.translations[languageIndex].keyMarketDrivers || '';
	form.marketOpportunities = offer.translations[languageIndex].marketOpportunities || '';
	form.keyHighlights = offer.translations[languageIndex].keyHighlights || '';
	form.additionalNotes = offer.translations[languageIndex].additionalNotes || '';
	form.clientNeeds = offer.translations[languageIndex].clientNeeds || '';
	form.clientBenefits = offer.translations[languageIndex].clientBenefits || '';
	form.tips = offer.translations[languageIndex].tips || '';
	form.competitors = offer.competitors;
	form.largestMarket = [];
	form.fastestGrowingMarket = [];
	form.deliveryLocation = [];
	offer.countries.forEach((country) => {
		let currCountry = validationService.countries.find(el => el.id === country.id);
		if (country.type === countriesEnums.LARGEST_MARKETS) {
			form.largestMarket.push({id: country.id, name: currCountry.name})
		} else if (country.type === countriesEnums.FASTEST_GROWING_MARKETS) {
			form.fastestGrowingMarket.push({id: country.id, name: currCountry.name})
		} else if (country.type === countriesEnums.DELIVERY_LOCATION) {
			form.deliveryLocation.push({id: country.id, name: currCountry.name})
		}
	});

	form.projectIndustry = [];
	offer.industries.forEach((industry) => {
		const currIndustry = validationService.industries.find(el => el.id === industry.id);
		if (industry.subIndustries.length === 0) {
			form.projectIndustry.push({id: "_" + currIndustry.id, name: currIndustry.name});
		} else {
			industry.subIndustries.forEach((subIndustry) => {
				const currSubIndustry = currIndustry.subIndustries.find(el => el.id === subIndustry.id);
				form.projectIndustry.push({id: currSubIndustry.id, name: currSubIndustry.name});
			});
		}
	});

	form.serviceLines = [];
	offer.serviceLines.forEach((serviceLine) => {
		const currServiceLine = validationService.serviceLines.find(el => el.id === serviceLine.id);
		if (serviceLine.subServiceLines.length === 0) {
			form.serviceLines.push({id: "_" + serviceLine.id, name: currServiceLine.name})
		} else {
			serviceLine.subServiceLines.forEach((subServiceLine) => {
				form.serviceLines.push({id: subServiceLine.id, name: subServiceLine.name})
			});
		}
	});

	form.techPractices = [];
	offer.techPractices.forEach((techPractice) => {
		const currTechPractice = validationService.techPractices.find(el => el.id === techPractice.id);
		if (techPractice.subTechPractices.length === 0) {
			form.techPractices.push({id: "_" + techPractice.id, name: currTechPractice.name})
		} else {
			techPractice.subTechPractices.forEach((subTechnology) => {
				form.techPractices.push({id: subTechnology.id, name: subTechnology.name})
			});
		}
	});

	form.mainTechPractice = [];
	const mainTechPractice = offer.techPractices.find(el => el.isMain);
	if(mainTechPractice){
		const mainTechPracticeItem = validationService.techPractices.find(el => el.id === mainTechPractice.id);
		if (mainTechPracticeItem) {
			form.mainTechPractice.push({id: mainTechPracticeItem.id, name: mainTechPracticeItem.name})
		}
	}

	form.toolsAndSystems = [];
	form.certifications = [];
	offer.qualificationAttributes.forEach((attribute) => {
		let currAttribute = validationService.toolsAndSystems.find(el => el.id === attribute.id);
		if (currAttribute){
			form.toolsAndSystems.push({id: attribute.id, name: currAttribute.name})
		}else{
			currAttribute = validationService.certifications.find(el => el.id === attribute.id);
			if(currAttribute){
				form.certifications.push({id: attribute.id, name: currAttribute.name});
			}else{
				console.error("Attribute not found in toolsAndSystems or certifications");
			}
		}
	});

	if(offer.globalOwners.length === 0){
		form.globalOwners = [{fullName: "", email: ""}];
	}else{
		form.globalOwners = [...offer.globalOwners.map(owner => {return {fullName: owner.fullName, email: owner.email, id: owner.id}})];
	}

	form.mainGlobalOwner = [];
	let mainGlobalOwner = offer.mainGlobalOwner;
	if(mainGlobalOwner){
		if (mainGlobalOwner.globalOwner) {
			mainGlobalOwner = {...mainGlobalOwner.globalOwner}
		}
		const mainGlobalOwnerItem = validationService.globalOwners.find(el => Number(el.id) === Number(mainGlobalOwner.id));
		if (mainGlobalOwnerItem) {
			form.mainGlobalOwner.push({...mainGlobalOwnerItem})
		}
	}

	if(offer.editors.length === 0){
		form.editors = [{editorFullName: "", editorEmail: ""}];
	}else{
		form.editors = [...offer.editors.map(owner => {return {editorFullName: owner.fullName, editorEmail: owner.email, id: owner.id}})];
	}

	form.mainClientPersona = offer.mainClientPersonas;

	form.lifecycle = offer.lifecycles;

	form.reference = [...offer.references.map(o => {return {referenceDescription: o.description, referenceUrl: o.url}})];

	form.reference = offer.references.map(o => {
		let item = {};
		const id = o.url.split('/').pop();
		item.id = id || "";
		const baseItem = validationService.projects.find(el => el.id == id);
		item.referenceTitle = o.description || "";
		item.firstDatePublished = baseItem?.management?.datePublish || "";
		return item;
	});
	if(form.reference.length === 0){
		form.reference.push({id: "", referenceTitle: "", firstDatePublished: ""});
	}

	form.relatedOffersEn = [];
	form.relatedOffersDe = [];
	form.relatedOffersFr = [];
	form.relatedOffersIt = [];
	form.relatedOffersJa = [];
	form.relatedOffersEs = [];
	offer.relatedOffers.forEach(o => {
		const langId = validationService.offers.find(el => el.id == o.id)?.translations?.[0]?.languageId
		if(!langId){
			return;
		}
		const lang = LANGUAGE_ARRAY.find(lang => lang.id === langId).lowerCase
		const currOffer = validationService.offers.find(el => el.id == o.id)
		if(!currOffer){
			return;
		}
		let item = {};
		item.id = o.id + ''
		item.relatedOffersTitle = currOffer.translations[0].title;
		if(currOffer.type === OFFER_TYPES_ENUM.GLOBAL){
			item.relatedOffersTitle += ' - Global'
		}else{
			const deliveryCountry = currOffer.countryRelations.find(el => el.type === countriesEnums.DELIVERY_LOCATION);
			const country = validationService.countries.find(el => el.id === deliveryCountry.countryId);
			item.relatedOffersTitle += ` - for ${country.name}`
		}

		form['relatedOffers' + lang[0].toUpperCase() + lang[1]].push(item);
	})

	form.type = [OFFER_TYPES.find(el => el.name.toUpperCase() === offer.type)];

	if(offer.annualRevenue){
		form.annualRevenue = [validationService.annualRevenues.find(el => el.key === offer.annualRevenue)]
	}else{
		form.annualRevenue = [validationService.annualRevenues.find(el => el.key === "N_A")]
	}

	if(offer.maturity){
		form.maturity = [validationService.maturities.find(el => el.key === offer.maturity)]
	}else{
		form.maturity = [validationService.maturities.find(el => el.key === "N_A")]
	}

	form.globalOffer = [];
	if(form.type?.[0].name?.toUpperCase() === OFFER_TYPES_ENUM.LOCALIZED){
		validationService.globalOffers.forEach((el) => {
			if(el.id == offer.globalOffers[0]?.id){
				form.globalOffer = [el];
			}
		});
	}

	form.recognitions = [];
	offer.recognitions.forEach(recognition => {
		const currRecognition = validationService.recognitions.find(r => r.id == recognition.id);
		if(currRecognition){
			form.recognitions.push(currRecognition);
		}
	})

	form.relatedSectors = [];
	offer.relatedSectors?.forEach(relatedSector => {
		const currSector = validationService.sectors?.find(s => s.id == relatedSector.id);
		if(currSector){
			form.relatedSectors.push(currSector);
		}
	})
}

export function fillOfferWithFormData(offer, form, validationService, newQualificationAttributes) {

	const offerTranslationIndex = 0
	let languageId = form.language[0]?.id || 1;
	offer.submission.languageId = languageId;

	offer['translations'] = [{languageId: languageId}];

	offer.videoLinks = [];
	form.videoLinks.forEach((videoLink) => {
		let item = {
			name: videoLink.videoLinkName,
			url: videoLink.videoLinkUrl,
		};
		if(videoLink.id){
			item.id = videoLink.id;
		}
		offer.videoLinks.push(item);
	})

	offer.lifecycles = form.lifecycle; // note the missing S
	offer.competitors = form.competitors.map(competitor => {
		let currComp = {name: competitor.name}
		if (competitor.id) {
			currComp.id = competitor.id;
		}
		return currComp
	})

	offer.references = [];
	form.reference.forEach((reference) => {
		if(reference.id === "" || reference.referenceTitle === "" || reference.firstDatePublished === ""){
			return;
		}
		const item = {};
		item.description = reference.referenceTitle;
		let dateFormat = new Date(reference.firstDatePublished);
		item.url = `${window.location.origin}/projects/${dateFormat.getFullYear()}/${dateFormat.getMonth() + 1}/${reference.id}`
		offer.references.push(item);
	})

	offer.relatedOffers = [];
	let allRelatedOffers = form.relatedOffersEn.concat(form.relatedOffersDe, form.relatedOffersFr, form.relatedOffersIt, form.relatedOffersJa, form.relatedOffersEs);
	allRelatedOffers.forEach((o) => {
		if(o.id === '' || o.relatedOffersTitle === ''){
			return;
		}
		const item = {};
		item.id = o.id + ''
		offer.relatedOffers.push(item)
	})

	offer.globalOwners = [];
	form.globalOwners.forEach((owner) => {
		if (owner.fullName !== "" && owner.email !== "") {
			let newGlobalOwner = {fullName: owner.fullName, email: owner.email}
			if (owner.id) {
				newGlobalOwner.id = owner.id;
			}
			offer.globalOwners.push(newGlobalOwner)
		}
	});

	if (form.mainGlobalOwner.length > 0) {
		offer.mainGlobalOwner = {id: null, globalOwner: {...form.mainGlobalOwner[0]}}
	}

	offer.editors = [];
	form.editors.forEach((editor) => {
		if (editor.editorFullName !== "" && editor.editorEmail !== "") {
			let newEditor = {fullName: editor.editorFullName, email: editor.editorEmail}
			if (editor.id) {
				newEditor.id = editor.id;
			}
			offer.editors.push(newEditor)
		}
	});

	offer.mainClientPersonas = form.mainClientPersona; //note the missing S

	offer.countries = [];
	form.largestMarket.forEach((market) => {
		offer.countries.push({id: market.id, type: countriesEnums.LARGEST_MARKETS})
	});
	form.fastestGrowingMarket.forEach((market) => {
		offer.countries.push({id: market.id, type: countriesEnums.FASTEST_GROWING_MARKETS})
	});
	form.deliveryLocation.forEach((location) => {
		if(location){
			offer.countries.push({id: location.id, type: countriesEnums.DELIVERY_LOCATION})
		}
	});

	offer.qualificationAttributes = [];
	form.toolsAndSystems.forEach((tool) => {
		if (tool.id) {
			offer.qualificationAttributes.push({id: tool.id})
		}
	});

	form.certifications.forEach((certification) => {
		if (certification.id) {
			offer.qualificationAttributes.push({id: certification.id})
		}
	})

	if (newQualificationAttributes?.length > 0) {
		newQualificationAttributes.forEach((attribute) => {
			offer.qualificationAttributes.push({id: attribute.id})
		});
	}

	offer.industries = [];
	if (validationService.industries.length > 0) {
		form?.projectIndustry?.forEach((formIndustry) => {
			let numberId;
			if (typeof formIndustry.id === "string") {
				const currId = formIndustry.id.replace?.('_', "")
				numberId = parseInt(currId)
			} else {
				numberId = formIndustry.id
			}
			validationService.industries.forEach((industry) => {
				if (typeof formIndustry.id === "string") {
					if(numberId === industry.id){
						offer.industries.push({id: industry.id, subIndustries: []})
					}
				}else{
					industry.subIndustries.forEach((subIndustry) => {
						if (subIndustry.id === numberId) {
							let industryIndex = offer.industries.findIndex(el => el.id === industry.id);
							if (industryIndex !== -1) {
								offer.industries[industryIndex].subIndustries.push({id: subIndustry.id})
							} else {
								offer.industries.push({id: industry.id, subIndustries: [{id: subIndustry.id}]})
							}
						}
					});
				}
			});
		});
	}

	offer.serviceLines = [];
	if (validationService.serviceLines.length > 0) {
		form.serviceLines.forEach((formServiceLine) => {
			let numberId;
			if (typeof formServiceLine.id === "string") {
				const currId = formServiceLine.id.replace?.('_', "")
				numberId = parseInt(currId)
			} else {
				numberId = formServiceLine.id
			}
			validationService.serviceLines.forEach((serviceLine) => {
				if (typeof formServiceLine.id === "string" ) {
					if(numberId === serviceLine.id){
						offer.serviceLines.push({id: serviceLine.id, subServiceLines: []})
					}
				}else{
					serviceLine.subServiceLines.forEach((subServiceLine) => {
						if (subServiceLine.id === numberId) {
							let serviceLineIndex = offer.serviceLines.findIndex(el => el.id === serviceLine.id);
							if (serviceLineIndex !== -1) {
								offer.serviceLines[serviceLineIndex].subServiceLines.push({id: subServiceLine.id})
							} else {
								offer.serviceLines.push({id: serviceLine.id, subServiceLines: [{id: subServiceLine.id}]})
							}
						}
					});
				}
			});
		});
	}

	offer.techPractices = [];
	if (validationService.techPractices.length > 0) {
		form.techPractices.forEach((formTechPractice) => {
			let numberId;
			if (typeof formTechPractice.id === "string") {
				const currId = formTechPractice.id.replace?.('_', "")
				numberId = parseInt(currId)
			} else {
				numberId = formTechPractice.id
			}

			validationService.techPractices.forEach((techPractice) => {
				if (typeof formTechPractice.id === "string") {
					if(numberId === techPractice.id){
						offer.techPractices.push({id: techPractice.id, subTechPractices: []})
					}
				}else{
					techPractice.subTechPractices.forEach((subTechnology) => {
						if (subTechnology.id === numberId) {
							let techPracticeIndex = offer.techPractices.findIndex(el => el.id === techPractice.id);
							if (techPracticeIndex !== -1) {
								offer.techPractices[techPracticeIndex].subTechPractices.push({id: subTechnology.id})
							} else {
								offer.techPractices.push({id: techPractice.id, subTechPractices: [{id: subTechnology.id}]})
							}
						}
					});
				}
			});
		});
	}

	if (form.mainTechPractice.length > 0) {
		const techPracticeId = form.mainTechPractice[0].id;
		offer.techPractices.find(el => el.id === techPracticeId).isMain = true;
	}

	offer.type = OFFER_TYPES.find(el => el.id === form.type[0]?.id)?.name || null;

	offer.annualRevenue = validationService.annualRevenues.find(el => el.id === form.annualRevenue[0]?.id)?.key || null;

	offer.maturity = validationService.maturities.find(el => el.id === form.maturity[0]?.id)?.key || null;

	if(form.type?.[0]?.name?.toUpperCase() === OFFER_TYPES_ENUM.LOCALIZED && form.globalOffer?.[0]?.id){
		offer.globalOffers = [{id: form.globalOffer?.[0]?.id}];
	}else{
		offer.globalOffers = [];
	}

	offer.recognitions = [];
	form.recognitions.forEach(recognition => {
		offer.recognitions.push({id: recognition.id})
	})

	offer.relatedSectors = [];
	form.relatedSectors.forEach(relatedSector => {
		offer.relatedSectors.push({id: relatedSector.id})
	})

	offer['translations'][offerTranslationIndex].title = form.title;
	offer['translations'][offerTranslationIndex].description = form.description;
	offer['translations'][offerTranslationIndex].biggestMarketConclusion = form.biggestMarketConclusion;
	offer['translations'][offerTranslationIndex].keyMarketDrivers = form.keyMarketDrivers;
	offer['translations'][offerTranslationIndex].marketOpportunities = form.marketOpportunities;
	offer['translations'][offerTranslationIndex].keyHighlights = form.keyHighlights;
	offer['translations'][offerTranslationIndex].additionalNotes = form.additionalNotes;
	offer['translations'][offerTranslationIndex].clientNeeds = form.clientNeeds;
	offer['translations'][offerTranslationIndex].clientBenefits = form.clientBenefits;
	offer['translations'][offerTranslationIndex].tips = form.tips;
	offer['translations'][offerTranslationIndex].offer = {id: offer.id};
}

export function addNewQualificationAttributes(qualificationAttributes) {
	return axios.post(`${endpoint}/qualification-attributes`, qualificationAttributes);
}

export function saveOffer(offer) {
	return axios.patch(`${endpoint}/offers/save`, offer);
}

export function saveOfferWithValidations(offer) {
	return axios.patch(`${endpoint}/offers/update`, offer);
}

export function createSnapshot(snapshot, type) {
	const body = {"snapshot": JSON.stringify(snapshot)}

	if (type === "offer") {
		body.offer = {'id': snapshot.id}
	} else {
		body.sector = {'id': snapshot.id}
	}

	return axios.post(`${URL}/gop/snapshots`, body);
}

export function saveThumbnail(offerId, thumbnail) {
	return axios.put(`${endpoint}/offers/files/images/upload?offerId=${offerId}&gopImageType=THUMBNAIL`, thumbnail, {
		headers: {
			'Content-Type': `image/jpeg`,
		}
	});
}

export function getThumbnail(offerId) {
	return axios.get(`${endpoint}/offers/files/images/get-by-offer-id-and-image-type?offerId=${offerId}&imageType=THUMBNAIL`);
}

export function deleteThumbnail(offerId) {
	return axios.delete(`${endpoint}/offers/files/images/delete?offerId=${offerId}&imageType=THUMBNAIL`);
}

//================================================================================================

export function getPanoramicPhoto(offerId) {
	return axios.get(`${endpoint}/offers/files/images/get-by-offer-id-and-image-type?offerId=${offerId}&imageType=PANORAMIC`);
}

export function savePanoramicPhoto(offerId, panoramicPhoto) {
	return axios.put(`${endpoint}/offers/files/images/upload?offerId=${offerId}&gopImageType=PANORAMIC`, panoramicPhoto, {
		headers: {
			'Content-Type': `image/jpeg`,
		}
	});
}

export function deletePanoramicPhoto(offerId) {
	return axios.delete(`${endpoint}/offers/files/images/delete?offerId=${offerId}&imageType=PANORAMIC`);
}

//================================================================================================
export function getMobilePanoramicPhoto(offerId) {
	return axios.get(`${endpoint}/offers/files/images/get-by-offer-id-and-image-type?offerId=${offerId}&imageType=MOBILE_PANORAMIC`);
}

export function saveMobilePanoramicPhoto(offerId, mobilePanoramicPhoto) {
	return axios.put(`${endpoint}/offers/files/images/upload?offerId=${offerId}&gopImageType=MOBILE_PANORAMIC`, mobilePanoramicPhoto, {
		headers: {
			'Content-Type': `image/jpeg`,
		}
	});
}

export function deleteMobilePanoramicPhoto(offerId) {
	return axios.delete(`${endpoint}/offers/files/images/delete?offerId=${offerId}&imageType=MOBILE_PANORAMIC`);
}
//================================================================================================
export function uploadFile(offerId, fileToUpload) {
	return axios.put(`${endpoint}/offers/files/upload?offerId=${offerId}`, fileToUpload, {
		headers: {
			'Content-Type': `multipart/form-data`,
		}
	});
}

export function getResources(offerId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllAdditionalResourcesByOfferId(offerId: ${offerId}) {
        		id
						name
						url
						awsKey
					}
   			 }`
		}
	})
		.then(response => {
			return response.data.data.getAllAdditionalResourcesByOfferId
		});

}

export function getRecognitions(offerId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllOfferRecognitionsByOfferId(offerId: ${offerId}) {
        		id
						translations {
							languageId
							title
						}
					}
   			 }`
		}
	})
		.then(response => {
			return response.data.data.getAllOfferRecognitionsByOfferId
		});

}

export function uploadResource(offerId, fileToUpload) {
	return axios.post(`${endpoint}/offers/${offerId}/additional-resources`, fileToUpload, {
		headers: {
			'Content-Type': `multipart/form-data;boundary=12345;`,
		}
	});
}

export function uploadRecognition(offerId, fileToUpload) {
	return axios.post(`${endpoint}/offers/${offerId}/recognitions`, fileToUpload, {
		headers: {
			'Content-Type': `multipart/form-data;boundary=12345;`,
		}
	});
}

export function deleteResource(offerId, resourceId) {
	return axios.delete(`${endpoint}/offers/${offerId}/additional-resources/${resourceId}`);
}

export function deleteRecognition(offerId, resourceId) {
	return axios.delete(`${endpoint}/offers/${offerId}/recognitions/${resourceId}`);
}

export function deleteFile(offerId, fileName) {
	return axios.delete(`${endpoint}/offers/files/delete?offerId=${offerId}&fileName=${fileName}`);
}

export function getFiles(offerId) {
	return axios.get(`${endpoint}/offers/files/${offerId}`).then(response => {
		return response.data;
	})
}

//================================================================================================

export function publishOffer(id) {
	return axios.post(`${endpoint}/offers/${id}/publish`).then(response => {
		return response.data;
	})
}

export function publishSectorPresentation(id) {
	return axios.post(`${endpoint}/sector-presentations/${id}/publish`).then(response => {
		return response.data;
	})
}

export function getUnpublishedOfferById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getUnpublishedOfferById(offerId: ${id}) {
						id,
						isActive,
						isPublished,
						creatorId,
						videoLinks {
							name
							url
						}
						relatedSectors {
							images {
									id
									url
									key
									type
							}
							id
							type
							isActive
							isPublished
							category
							translations {
                id
                languageId
                title
                description
            }
						}
						type,
						annualRevenue,
						maturity,
						userFavorites {
							userId
						},
						recognitions {
							id,
							isActive
            	isPublished
            	additionalLinks {
            		name,
            		url
            	},
            	additionalResources {
								name,
								url
            	},
							translations {
								languageId,
								title
							},
							images {
                type
                url
            	}
						},
						additionalResources{
							id,
							url,
							name
						},
						relatedOffers{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						localizedOffers{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalOffers{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						}
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
							biggestMarketConclusion,
							keyMarketDrivers,
							marketOpportunities,
							keyHighlights,
							additionalNotes,
							clientNeeds,
							clientBenefits,
							tips
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							isMain,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						mainGlobalOwner {
							globalOwner {
								id,
								fullName,
								email
							}
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						},
						competitors {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getUnpublishedOfferById
		});
}

export function getPublishedOfferById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getPublishedOfferById(offerId: ${id}) {
						id,
						isActive,
						isPublished,
						creatorId,
						videoLinks {
							name
							url
						}
						relatedSectors {
							images {
									id
									url
									key
									type
							}
							id
							type
							isActive
							isPublished
							category
							translations {
								id
								languageId
								title
								description
							}
						}
						annualRevenue,
						maturity,
						userFavorites {
							userId
						},
						additionalResources{
							id,
							url,
							name
						},
						recognitions {
							id,
							isActive
            	isPublished
            	additionalLinks {
            		name,
            		url
            	},
            	additionalResources {
								name,
								url
            	},
							translations {
								languageId,
								title
							},
							images {
                type
                url
            	}
						},
						relatedOffers{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						}
						type,
						localizedOffers{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalOffers{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						}
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
							biggestMarketConclusion,
							keyMarketDrivers,
							marketOpportunities,
							keyHighlights,
							additionalNotes,
							clientNeeds,
							clientBenefits,
							tips
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							isMain,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						mainGlobalOwner {
							globalOwner {
								id,
								fullName,
								email
							}
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						},
						competitors {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getPublishedOfferById
		});
}

export function deleteOfferById(offerId) {
	return axios.delete(`${endpoint}/offers/${offerId}/delete`)
		.then(response => {
			return response.data;
		})
}

export function deleteSectorPresentationById(sectorId) {
	return axios.delete(`${endpoint}/sector-presentations/${sectorId}/delete`)
		.then(response => {
			return response.data;
		})
}

export function archiveOfferById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation ArchiveOffer {
					archiveOffer(offerId: ${id}) {
							id,
							isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.archiveOffer
		});
}

export function unArchiveOfferById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation UnArchiveOffer {
					unArchiveOffer(offerId: ${id}) {
						id,
						isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.unArchiveOffer
		});
}

export function archiveSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation ArchiveSector {
					archiveSector(sectorId: ${id}) {
							id,
							isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.archiveSector
		});
}

export function unArchiveSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`mutation UnArchiveSector {
					unArchiveSector(sectorId: ${id}) {
							id,
							isActive
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.unArchiveSector
		});
}

export function addToOfferFavorites(offerId, userId) {
	return axios.post(`${endpoint}/offers/${offerId}/add-favorite?userId=${userId}`);
}

export function removeFromOfferFavorites(offerId, userId) {
	return axios.post(`${endpoint}/offers/${offerId}/remove-favorite?userId=${userId}`);
}

export function addToSectorFavorites(sectorId, userId) {
	return axios.post(`${endpoint}/sector-presentations/${sectorId}/add-favorite?userId=${userId}`);
}

export function removeFromSectorFavorites(sectorId, userId) {
	return axios.post(`${endpoint}/sector-presentations/${sectorId}/remove-favorite?userId=${userId}`);
}

export function getUrlParams() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const params = {};

	for (const [name, value] of urlParams) {
		params[name] = value;
	}

	return params;
}

export function getOffersIdsByFilterCriteria(criteria, text) {
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if(criteria.excludeIds){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}excludedIds:[${criteria.excludeIds.join(',')}]}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', OFFER_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', OFFER_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', OFFER_TYPES_ENUM.LOCALIZED);
	}
	if (text) {
		criteriaString = criteriaString.replace("}", `,text:"${text}"}`);
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchOfferByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					globalOffers{
						id
					}
				}
			}`
		}
	});
}

export function getRelatedOffersByFilterCriteria(criteria, text) {
	let criteriaString = JSON.stringify(criteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace("}", `,text:"${text}"}`);
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchOfferByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					translations {
            languageId
            title
        	}
				}
			}`
		}
	});
}

export function getOfferDataStatistics(criteria, text){
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', OFFER_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', OFFER_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', OFFER_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}creationDate: {from:"1999-01-01", to:"2099-12-31"}}`);
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${0}, size: ${9999}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchOfferByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					statistics {
						id,
						action,
						date,
					}
					views,
					translations {
						title,
						languageId
					}
				}
			}`
		}
		});
}

export function getOfferDataStatisticsNew(criteria, text){
	if (text) {
		criteria.text = text
	}

	return axios.post(`${statisticEndpoint}/offers-statistics`, criteria);
}

export function getOffersReportDataWithCriteria(criteria, text, dateFrom, dateTo) {
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', OFFER_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', OFFER_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', OFFER_TYPES_ENUM.LOCALIZED);
	}
	if(dateFrom && dateTo){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}creationDate: {from:"${dateFrom}", to:"${dateTo}"}}`);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${0}, size: ${99999}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchOfferByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					creatorId,
					videoLinks {
						name
						url
					}
					userFavorites {
						userId
					},
					isActive,
					isPublished,
					type,
					submission {
						id,
						languageId,
						creationDateTime,
						publishedDateTime
					},
					references {
						id,
						description,
						url
					},
					recognitions {
						translations {
                languageId
                title
            }
					},
					industryRelations {
						id,
						industryId,
						subIndustryRelations {
							id,
							subIndustryId
						}
					},
					translations {
						id,
						languageId,
						title,
						description,
					},
					countryRelations {
						id,
						countryId,
						type
					},
					serviceLineRelations {
						id,
						serviceLineId,
						subServiceLineRelations {
							id,
							subServiceLineId
						}
					},
					techPracticeRelations {
						id,
						techPracticeId,
						isMain,
						subTechPracticeRelations {
							id,
							subTechPracticeId
						}
					},
					qualificationAttributeRelations {
						id,
						qualificationAttributeId
					},
					globalOwners {
						id,
						fullName,
						email
					},
					editors{
						id,
						fullName,
						email
					},
					mainClientPersonas {
						id,
						jobDescription
					},
					lifecycles {
						id,
						name
					},
					competitors {
						id,
						name
					}
				}
			}`
		}
	});
}

export function getOffersByFilterCriteria(criteria, text, page, pageSize, order) {
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(order){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}sort:{order:"${order}", by:"id"}}`);
	}
	if(criteria.excludeIds){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}excludedIds:[${criteria.excludeIds.join(',')}]}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', OFFER_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', OFFER_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', OFFER_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${page || 0}, size: ${pageSize || 16}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchOfferByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					isActive,
					isPublished,
					type,
					userFavorites {
						userId
					},
					editors{
						id,
						fullName,
						email
					},
					countryRelations{
						countryId,
						type
					},
					submission {
						id,
						languageId,
						creationDateTime,
						publishedDateTime
					}
					images {
						url,
						type
					},
					translations {
						languageId,
						title,
						description
					},
					files {
						url,
						type
					},
					techPracticeRelations {
						techPracticeId,
						isMain,
						subTechPracticeRelations {
							subTechPracticeId
						}
					}
				}
			}`
		}
	});
}

export function getGlobalSearchOffersByCriteria(criteria, text, page, pageSize, order) {
	let criteriaString = JSON.stringify(criteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(order){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}sort:{order:"${order}"}}`);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${page || 0}, size: ${pageSize || 16}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchOfferByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					type,
					translations {
						languageId,
						title,
						description,
						tips,
						biggestMarketConclusion,
						keyMarketDrivers,
						marketOpportunities,
						keyHighlights,
						additionalNotes,
						clientNeeds,
						clientBenefits
					}
				}
			}`
		}
	});
}

export function getSectorDataStatistics(criteria, text){
	let currCriteria = JSON.parse(JSON.stringify(criteria));
	if(currCriteria.excludeIds){
		delete currCriteria.excludeIds
	}
	let criteriaString = JSON.stringify(currCriteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', OFFER_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', OFFER_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', OFFER_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}creationDate: {from:"1999-01-01", to:"2099-12-31"}}`);
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${0}, size: ${9999}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchSectorByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					statistics {
						id,
						action,
						date,
					}
					views,
					translations {
						title,
						languageId
					}
				}
			}`
		}
	});
}


export function getSectorDataStatisticsNew(criteria, text){
	if (text) {
		criteria.text = text
	}

	return axios.post(`${statisticEndpoint}/sectors-statistics`, criteria);
}



export function getSectorsByFilterCriteria(criteria, text, page, pageSize, order) {
	let criteriaString = JSON.stringify(criteria).replace(/"([^"]+)":/g, '$1:');
	if (text) {
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}text:"${text}"}`);
	}
	if(order){
		criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}sort:[{order:"${order}", by:"id"}]}`);
	}
	if(criteria.types){
		criteriaString = criteriaString.replace('"GLOBAL"', OFFER_TYPES_ENUM.GLOBAL)
			.replace('"LOCAL"', OFFER_TYPES_ENUM.LOCAL)
			.replace('"LOCALIZED"', OFFER_TYPES_ENUM.LOCALIZED);
	}
	criteriaString = criteriaString.replace(new RegExp('}$'), `${criteriaString.length > 2 ? ",":''}pageable:{page:${page || 0}, size: ${pageSize || 16}}}`);

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
				searchSectorByCriteria(
					criteriaFilter:${criteriaString}
				) {
					id,
					isActive,
					isPublished,
					category,
					type,
					userFavorites {
						userId
					},
					editors{
						id,
						fullName,
						email
					},
					recognitions {
						id,
						additionalLinks {
            	name,
            	url
            },
            additionalResources {
							name,
							url
            },
						translations {
							languageId
							title
						}
					},
					countryRelations{
						countryId,
						type
					},
					submission {
						id,
						languageId,
						creationDateTime,
						publishedDateTime
					}
					images {
						url,
						type
					},
					translations {
						languageId,
						title,
						description
					},
					files {
						url,
						type
					},
					industryRelations {
						industryId,
						isMain
					}
				}
			}`
		}
	});
}

export function fetchLatestPublishedOffers(offersNumber) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getLatestPublishedOffers(numberOfOffers: ${offersNumber}) {
							id,
							images {
									id,
									 url,
									type
							},
							type,
							countryRelations{
								countryId,
            		type
							},
							translations {
									id,
									languageId,
									title
							},
							submission {
									publishedDateTime,
									languageId
							}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getLatestPublishedOffers
		});
}

export function getPublishedSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getPublishedSectorById(sectorId: ${id}) {
						id,
						isActive,
						category,
						creatorId,
						isPublished,
						videoUrl,
						type,
						relatedOffers {
							images {
								id
								url
								key
								type
							}
							id
							type
							isActive
							isPublished
							translations {
								id
								languageId
								title
								description
							}
						}
						userFavorites {
							userId
						},
						recognitions {
							id,
							isActive
            	isPublished
            	additionalLinks {
            		name,
            		url
            	},
            	additionalResources {
								name,
								url
            	},
							translations {
								languageId,
								title
							},
							images {
                type
                url
            	}
						},
						additionalResources{
							id,
							url,
							name
						},
						relatedSectors{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						localizedSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							isMain,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						mainGlobalOwner {
							globalOwner {
								id,
								fullName,
								email
							}
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getPublishedSectorById
		});
}

export function getUnpublishedSectorPresentationById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getUnpublishedSectorById(sectorId: ${id}) {
						id,
						isActive,
						isPublished,
						category,
						creatorId,
						videoUrl,
						type,
						relatedOffers {
							images {
								id
								url
								key
								type
							}
							id
							type
							isActive
							isPublished
							translations {
								id
								languageId
								title
								description
							}
						}
						userFavorites {
							userId
						},
						recognitions {
							id,
							isActive
            	isPublished
            	additionalLinks {
            		name,
            		url
            	},
            	additionalResources {
								name,
								url
            	},
							translations {
								languageId,
								title
							},
							images {
                type
                url
            	}
						},
						additionalResources{
							id,
							url,
							name
						},
						relatedSectors{
							id,
							type,
							isPublished,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						localizedSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						globalSectors{
							id,
							type,
							countryRelations{
								countryId,
								type
							}
							translations{
								languageId,
								title
							},
							images{
								url,
								type
							}
						},
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						industryRelations {
							id,
							industryId,
							isMain,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						mainGlobalOwner {
							globalOwner {
								id,
								fullName,
								email
							}
						},
						editors{
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getUnpublishedSectorById
		});
}

export function fetchOffers(params, userId) {
	let by;
	let order;

	if (params) {
		[by, order] = params.sort ? params.sort.split(",") : 'management_firstDatePublish,DESC'.split(",");
	}

	let text;
	if (params.text) {
		text = encodeURIComponent(params.text)
	}

	let qualificationAttributes = []
	if (params.certificates) {
		let certificates = params.certificates.split(",")
		qualificationAttributes = [...new Set([...certificates])];
	}

	if (params.tools) {
		let tools = params.tools.split(",")
		qualificationAttributes = [...new Set([...tools, ...qualificationAttributes])];
	}

	let dateFrom, dateTo, textFrom, textTo;
	if(params.publicationDates){
		dateFrom = params.publicationDates.split("_")[0].split('-');
		dateTo = params.publicationDates.split("_")[1].split('-');
		textFrom = `${dateFrom[2]}-${dateFrom[1]}-${dateFrom[0]}`;
		textTo = `${dateTo[2]}-${dateTo[1]}-${dateTo[0]}`;
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					searchOfferByCriteria(
						criteriaFilter: {
							${text ? `text: "${text}"` : ''}
							sort: { by: "${by}", order: "${order}" }
							${params.deliveryLocations ? `deliveryLocations: [${params.deliveryLocations.split(",")}]` : ''}
							${params.industries ? `industries: [${params.industries.split(",")}]` : ''}
							${params.subIndustries ? `subIndustries: [${params.subIndustries.split(",")}]` : ''}
							${params.serviceLines ? `serviceLines: [${params.serviceLines.split(",")}]` : ''}
							${params.subServiceLines ? `subServiceLines: [${params.subServiceLines.split(",")}]` : ''}
							${params.techPractices ? `techPractices: [${params.techPractices.split(",")}]` : ''}
							${params.subTechPractices ? `subTechPractices: [${params.subTechPractices.split(",")}]` : ''}
							${params.qualificationAttributes ? `qualificationAttributes: [${qualificationAttributes.join(",")}]` : ''}
							${params.recognitions ? `recognitions: [${params.recognitions.split(",")}]` : ''}
							${params.mainClientPersonas ? `mainClientDomain: [${params.mainClientPersonas}]` : ''}
							${params.globalOwners ? `owners: [${params.globalOwners.split(",")}]` : ''}
							${params.showOnlyFavourites === 'true' ? `favouriteUserId: ${userId}` : ``}
							${params.isManagement === 'true' ? `isManagement: true` : ``}
							${params.isManagement === 'true' ? `types:[GLOBAL,LOCAL,LOCALIZED]` : ``}
							${params.publicationDates ? `creationDate: {from:"${textFrom}", to:"${textTo}"}` : ''}
						}
					) {
						submission {
							id
							languageId
							creationDateTime
							publishedDateTime
						}
						views
						type
						id
						images {
							id
							url
							key
							type
						}
						translations {
							languageId
							title
							description
						}
						userFavorites {
							id
							userId
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchOfferByCriteria
		});
}

export function fetchOffersCount(params, userId) {
	let by;
	let order;

	if (params) {
		[by, order] = params.sort ? params.sort.split(",") : 'management_firstDatePublish,DESC'.split(",");
	}

	let text;
	if (params.text) {
		text = encodeURIComponent(params.text)
	}

	let qualificationAttributes = []
	if (params.certificates) {
		let certificates = params.certificates.split(",")
		qualificationAttributes = [...new Set([...certificates])];
	}

	if (params.tools) {
		let tools = params.tools.split(",")
		qualificationAttributes = [...new Set([...tools, ...qualificationAttributes])];
	}

	let dateFrom, dateTo, textFrom, textTo;
	if(params.publicationDates){
		dateFrom = params.publicationDates.split("_")[0].split('-');
		dateTo = params.publicationDates.split("_")[1].split('-');
		textFrom = `${dateFrom[2]}-${dateFrom[1]}-${dateFrom[0]}`;
		textTo = `${dateTo[2]}-${dateTo[1]}-${dateTo[0]}`;
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					searchOfferByCriteria(
						criteriaFilter: {
							${text ? `text: "${text}"` : ''}
							sort: { by: "${by}", order: "${order}" }
							${params.deliveryLocations ? `deliveryLocations: [${params.deliveryLocations.split(",")}]` : ''}
							${params.industries ? `industries: [${params.industries.split(",")}]` : ''}
							${params.subIndustries ? `subIndustries: [${params.subIndustries.split(",")}]` : ''}
							${params.serviceLines ? `serviceLines: [${params.serviceLines.split(",")}]` : ''}
							${params.subServiceLines ? `subServiceLines: [${params.subServiceLines.split(",")}]` : ''}
							${params.techPractices ? `techPractices: [${params.techPractices.split(",")}]` : ''}
							${params.subTechPractices ? `subTechPractices: [${params.subTechPractices.split(",")}]` : ''}
							${params.recognitions ? `recognitions: [${params.recognitions.split(",")}]` : ''}
							${params.qualificationAttributes ? `qualificationAttributes: [${qualificationAttributes.join(",")}]` : ''}
							${params.mainClientPersonas ? `mainClientDomain: [${params.mainClientPersonas}]` : ''}
							${params.globalOwners ? `owners: [${params.globalOwners.split(",")}]` : ''}
							${params.showOnlyFavourites === 'true' ? `favouriteUserId: ${userId}` : ``}
							${params.isManagement === 'true' ? `isManagement: true` : ``}
							${params.isManagement === 'true' ? `types:[GLOBAL,LOCAL,LOCALIZED]` : ``}
							${params.publicationDates ? `creationDate: {from:"${textFrom}", to:"${textTo}"}` : ''}
						}
					) {
						id
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchOfferByCriteria
		});
}

export function fetchSectorPresentations(params, userId) {
	let by;
	let order;

	if (params) {
		[by, order] = params.sort ? params.sort.split(",") : 'management_firstDatePublish,DESC'.split(",");
	}

	let text;
	if (params.text) {
		text = encodeURIComponent(params.text)
	}

	let qualificationAttributes = []
	if (params.certificates) {
		let certificates = params.certificates.split(",")
		qualificationAttributes = [...new Set([...certificates])];
	}

	if (params.tools) {
		let tools = params.tools.split(",")
		qualificationAttributes = [...new Set([...tools, ...qualificationAttributes])];
	}

	let dateFrom, dateTo, textFrom, textTo;
	if(params.publicationDates){
		dateFrom = params.publicationDates.split("_")[0].split('-');
		dateTo = params.publicationDates.split("_")[1].split('-');
		textFrom = `${dateFrom[2]}-${dateFrom[1]}-${dateFrom[0]}`;
		textTo = `${dateTo[2]}-${dateTo[1]}-${dateTo[0]}`;
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					searchSectorByCriteria(
						criteriaFilter: {
							${text ? `text: "${text}"` : ''}
							sort: { by: "${by}", order: "${order}" }
							${params.deliveryLocations ? `deliveryLocations: [${params.deliveryLocations.split(",")}]` : ''}
							${params.industries ? `industries: [${params.industries.split(",")}]` : ''}
							${params.subIndustries ? `subIndustries: [${params.subIndustries.split(",")}]` : ''}
							${params.serviceLines ? `serviceLines: [${params.serviceLines.split(",")}]` : ''}
							${params.subServiceLines ? `subServiceLines: [${params.subServiceLines.split(",")}]` : ''}
							${params.techPractices ? `techPractices: [${params.techPractices.split(",")}]` : ''}
							${params.subTechPractices ? `subTechPractices: [${params.subTechPractices.split(",")}]` : ''}
							${params.recognitions ? `recognitions: [${params.recognitions.split(",")}]` : ''}
						${params.qualificationAttributes ? `qualificationAttributes: [${qualificationAttributes.join(",")}]` : ''}
							${params.mainClientPersonas ? `mainClientDomain: [${params.mainClientPersonas}]` : ''}
							${params.globalOwners ? `owners: [${params.globalOwners.split(",")}]` : ''}
							${params.showOnlyFavourites === 'true' ? `favouriteUserId: ${userId}` : ``}
							${params.isManagement === 'true' ? `isManagement: true` : ``}
							${params.isManagement === 'true' ? `types:[GLOBAL,LOCAL,LOCALIZED]` : ``}
							${params.publicationDates ? `creationDate: {from:"${textFrom}", to:"${textTo}"}` : ''}
						}
					) {
						submission {
							id
							languageId
							creationDateTime
							publishedDateTime
						}
						views
						type
						id
						category
						images {
							id
							url
							key
							type
						}
						translations {
							languageId
							title
							description
						}
						userFavorites {
							id
							userId
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchSectorByCriteria
		});
}
